module.exports = __webpack_public_path__ + "media/images/emoticons/fullmoon-0f029aa276f2838a62496ccbfa8ad885.gif";